/* MV Sortiment assets/mv-sortiment.konto-seite.js - Paket A-3 - 2026-10-10 */
/*
 * Kontoseite "Meine Werkzeuge" (Paket A-3): /pages/meine-werkzeuge, Markup sections/mv-konto-werkzeuge.liquid, Stile
 * assets/mv-sortiment.konto-seite.css. Plan docs/mv-vending/sortiment/planung/plan-konto-fortschritt-2026-10-09.md
 * (Vertrag Abschnitt 3), Backend _docs/a1-konto-backend.md, Speicherschicht _docs/a2a-konto-speicherschicht.md,
 * Doku _docs/a3-konto-seite.md.
 *
 * Ablauf je Wurzel [data-mv-kontoseite]:
 *   ohne Login (window.mvKonto.eingeloggt nicht true)  -> Zustand gast, Login-Link aus window.mvKonto.loginUrl
 *                                                         (mit return_to), keine Anfrage
 *   mit Login -> Zustand laedt, GET basis + '/uebersicht' (credentials same-origin, Accept application/json):
 *     200 { ok: true, werkzeuge: [...] }              -> liste (je Werkzeug Name, Bezeichnung, zuletzt gespeichert,
 *                                                         Weiterarbeiten, Loeschen) oder leer
 *     401 (nicht_angemeldet)                          -> gast, mit Ansage
 *     sonst (Netz, 403, 404 oder HTML ohne App-Proxy, 429, 5xx, kein JSON)
 *                                                      -> fehler, mit Ansage und "Erneut versuchen"
 *   Loeschen: Rueckfrage in der Zeile (Gruppe mit Frage, Endgueltig loeschen, Abbrechen; Escape bricht ab), dann
 *     DELETE basis + '/stand?werkzeug=<schluessel>'. ok -> Zeile weg, Ansage, Fokus auf die Ueberschrift der Liste
 *     (letzte Zeile: Zustand leer); 401 -> gast; sonst Fehler in der Zeile, Ansage, Fokus zurueck auf Loeschen.
 *   Bewusst nicht ueber MVKonto.loeschen: der Browser-Spiegel (mv-konto:<werkzeug>) bleibt synchron stehen, und das
 *   Werkzeug findet beim naechsten Oeffnen das Konto leer und verwirft Spiegel und Altschluessel (A-2a, "im Konto
 *   geloescht"). MVKonto.loeschen raeumt Altschluessel nur, wo das Werkzeug sie anmeldet (nicht auf dieser Seite): ein
 *   geteilter Altschluessel (Businessplan, mv-vorlagen:businessplan) wuerde den Stand beim naechsten Besuch neu
 *   hochladen.
 *   Zurueck-Taste (pageshow aus dem Cache) laedt die Liste neu; shopify:section:load startet die Sektion neu.
 *   Jeder Zustandswechsel meldet "mv-kontoseite:zustand" (detail.zustand) an der Wurzel, fuer Paket A-4 (Profil).
 * Konfiguration: window.mvKonto (snippets/mv-konto-status.liquid, Vertrag); fehlt es, gelten die Werte der Sektion
 * (data-mv-kontoseite-angemeldet und -basis, Liquid customer). Keine Kunden-ID im Browser: die Person erkennt allein
 * der App-Proxy. Saetze stehen im Markup (Textbaukasten KTO-12 bis KTO-25), das Verzeichnis der Werkzeuge (Name,
 * Ziel, Icon) in template[data-mv-kontoseite-werkzeug|praefix]; im Skript steht nur die Einheit "Uhr" des Zeitformats
 * KTO-08 (wie konto.js) und der Spiegel der Werkzeugnamen des Backends (regeln.ts, nur zum Vergleich, nie sichtbar).
 * Teil von assets/mv-sortiment.js (_build/konkat.sh): Byte-Reihenfolge stellt diese Datei vor konto.js ("-" vor
 * "."); der Start laeuft wie bei A-2a per Mikrotask nach dem ganzen Buendel. Unter Node (Tests) liefert die Datei die
 * reinen Funktionen. Kommentare und Datei ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-10.1';
  var SCHLUESSEL_RE = /^[a-z0-9-]{2,80}$/;   /* Vertrag Abschnitt 3 (Grenze 80 seit 10.10.2026) */
  var REST_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  var MAX_TITEL = 80;
  var ZUSTAENDE = ['gast', 'laedt', 'liste', 'leer', 'fehler'];
  var UHR = 'Uhr';

  /* Spiegel von werkzeugName() in supabase/functions/mv-shop-konto/regeln.ts: so benennt das Backend ein Werkzeug,
     wenn der Stand keinen Titel traegt. Nur zum Vergleich (Bezeichnung zeigen oder nicht), nie als Anzeige. */
  var NAMEN = {
    'businessplan': 'Businessplan',
    'kalkulator': 'Automaten-Kalkulator',
    'finvergleich': 'Finanzierungsvergleich',
    'vertrag-aufstellung': 'Aufstellungsvertrag',
    'spiralen': 'Spiralen-Berater',
    'spacer': 'Spacer-Berater',
    'standort-check': 'Standort-Check',
    'pflichten-check': 'Pflichten-Check',
    'merkliste': 'Merkliste'
  };
  var PRAEFIXE = [['akademie-', 'Akademie'], ['konfigurator-', 'Konfigurator']];

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  function hat(o, k) {
    return !!o && Object.prototype.hasOwnProperty.call(o, k);
  }

  function istListe(x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  }

  function istObjekt(x) {
    return !!x && typeof x === 'object' && !istListe(x);
  }

  function zeitWert(iso) {
    return typeof iso === 'string' && iso ? Date.parse(iso) : NaN;
  }

  function zwei(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // KTO-08: "14:32 Uhr" am selben Tag, sonst "09.10.2026, 14:32 Uhr" (Ortszeit, geschuetztes Leerzeichen vor Uhr)
  function zeitText(isoText, jetzt) {
    var t = zeitWert(isoText);
    if (!isFinite(t)) return '';
    var d = new Date(t);
    var h = new Date(typeof jetzt === 'number' && isFinite(jetzt) ? jetzt : Date.now());
    var uhr = zwei(d.getHours()) + ':' + zwei(d.getMinutes()) + '\u00a0' + UHR;
    if (d.getFullYear() === h.getFullYear() && d.getMonth() === h.getMonth() && d.getDate() === h.getDate()) return uhr;
    return zwei(d.getDate()) + '.' + zwei(d.getMonth() + 1) + '.' + d.getFullYear() + ', ' + uhr;
  }

  // Zeichen statt UTF-16-Einheiten (keine halben Surrogate), wie kuerze() im Backend
  function zeichen(text) {
    var s = String(text);
    if (typeof Array.from === 'function') return Array.from(s);
    return s.split('');
  }

  function kuerze(text, n) {
    var z = zeichen(text);
    return z.length <= n ? String(text) : z.slice(0, n).join('');
  }

  // Einzeilig wie einzeilig() im Backend: Steuerzeichen zu Leerzeichen, Leerraum zusammengefasst, getrimmt
  function einzeilig(text) {
    // eslint-disable-next-line no-control-regex
    return String(text).replace(/[\u0000-\u001f\u007f-\u009f]/g, ' ').replace(/\s+/g, ' ').replace(/^ | $/g, '');
  }

  function werkzeugName(w) {
    if (hat(NAMEN, w)) return NAMEN[w];
    for (var i = 0; i < PRAEFIXE.length; i++) {
      var p = PRAEFIXE[i][0];
      if (w.indexOf(p) === 0 && w.length > p.length) return PRAEFIXE[i][1] + ': ' + w.slice(p.length);
    }
    return w;
  }

  // Antwort von GET /uebersicht -> gepruefte Liste (Reihenfolge des Backends: neueste zuerst) oder null
  function eintraege(daten) {
    if (!istObjekt(daten) || !istListe(daten.werkzeuge)) return null;
    var gesehen = {};
    var aus = [];
    daten.werkzeuge.forEach(function (e) {
      if (!istObjekt(e) || typeof e.werkzeug !== 'string' || !SCHLUESSEL_RE.test(e.werkzeug) || hat(gesehen, e.werkzeug)) return;
      gesehen[e.werkzeug] = true;
      aus.push({
        werkzeug: e.werkzeug,
        titel: typeof e.titel === 'string' ? kuerze(einzeilig(e.titel), MAX_TITEL) : '',
        aktualisiert_am: isFinite(zeitWert(e.aktualisiert_am)) ? e.aktualisiert_am : null
      });
    });
    return aus;
  }

  // Verzeichnis: [{ werkzeug } oder { praefix }, name, url, anker]; genauer Schluessel vor dem laengsten Praefix
  function finde(w, verzeichnis) {
    var treffer = null;
    var laenge = -1;
    (verzeichnis || []).forEach(function (v) {
      if (v.werkzeug && v.werkzeug === w) {
        treffer = { eintrag: v, rest: '' };
        laenge = Infinity;
      } else if (v.praefix && w.indexOf(v.praefix) === 0 && w.length > v.praefix.length && v.praefix.length > laenge) {
        treffer = { eintrag: v, rest: w.slice(v.praefix.length) };
        laenge = v.praefix.length;
      }
    });
    return treffer;
  }

  // Ziel nur fuer sichere Pfade dieser Seite (beginnt mit einem Schraegstrich, kein Protokoll)
  function sichererPfad(p) {
    return typeof p === 'string' && /^\/(?!\/)[A-Za-z0-9_\/#?=&.-]*$/.test(p);
  }

  // Ansicht eines Eintrags: Name (Verzeichnis), Bezeichnung (Titel des Stands, sonst beim Praefix der Rest des
  // Schluessels), Ziel fuer Weiterarbeiten (leer = kein Link), Beschriftung fuer Screenreader und Ansagen
  function ansicht(e, verzeichnis) {
    var t = finde(e.werkzeug, verzeichnis);
    var titel = e.titel || '';
    var name;
    var bezeichnung = '';
    var url = '';
    if (t) {
      name = t.eintrag.name || werkzeugName(e.werkzeug);
      if (titel && titel !== name) {
        if (titel !== kuerze(werkzeugName(e.werkzeug), MAX_TITEL)) bezeichnung = titel;
        else if (t.rest) bezeichnung = t.rest;
      } else if (!titel && t.rest) bezeichnung = t.rest;
      if (t.eintrag.url && (!t.rest || REST_RE.test(t.rest))) {
        var ziel = t.eintrag.url + t.rest + (t.eintrag.anker || '');
        if (sichererPfad(ziel)) url = ziel;
      }
    } else {
      // unbekanntes Werkzeug (neuer Schluessel): Titel des Backends, ohne Ziel
      name = titel || e.werkzeug;
    }
    return {
      werkzeug: e.werkzeug,
      name: name,
      bezeichnung: bezeichnung,
      url: url,
      beschriftung: bezeichnung ? name + ' \u00b7 ' + bezeichnung : name,
      treffer: t ? t.eintrag : null
    };
  }

  // Antwort des Proxys ({ netz } oder { status, daten }): 'ok' | 'gast' | 'fehler'
  function art(r) {
    if (!r || r.netz) return 'fehler';
    if (r.status === 401) return 'gast';
    if (r.status >= 200 && r.status < 300 && istObjekt(r.daten) && r.daten.ok === true) return 'ok';
    return 'fehler';
  }

  // Basis wie konto.js: nur ein Pfad dieser Seite ('/apps/mv'), ohne Schraegstrich am Ende
  function basisAus(b) {
    return typeof b === 'string' && /^\/[A-Za-z0-9_\/-]*$/.test(b) && b.indexOf('//') === -1 ? b.replace(/\/+$/, '') : '';
  }

  // Login- und Kontoadresse wie konto.js: Pfad dieser Seite oder https
  function adresseAus(a) {
    return typeof a === 'string' && /^(?:\/(?!\/)|https:\/\/)/.test(a) ? a : '';
  }

  var logik = {
    VERSION: VERSION,
    SCHLUESSEL_RE: SCHLUESSEL_RE,
    MAX_TITEL: MAX_TITEL,
    ZUSTAENDE: ZUSTAENDE,
    NAMEN: NAMEN,
    PRAEFIXE: PRAEFIXE,
    zeitText: zeitText,
    kuerze: kuerze,
    einzeilig: einzeilig,
    werkzeugName: werkzeugName,
    eintraege: eintraege,
    finde: finde,
    ansicht: ansicht,
    art: art,
    basisAus: basisAus,
    adresseAus: adresseAus
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.kontoseite) return;

  var WURZEL = '[data-mv-kontoseite]';
  var seiten = [];

  function setzeText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function zeigeEl(el, an) {
    if (el && el.hidden === an) el.hidden = !an;
  }

  function fokus(el) {
    if (el && typeof el.focus === 'function') {
      try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
    }
  }

  function leere(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  function klonVorlage(vorlage) {
    if (!vorlage) return null;
    var inhalt = vorlage.content || vorlage;
    var kind = inhalt.firstElementChild || null;
    return kind ? kind.cloneNode(true) : null;
  }

  function anfrage(methode, url) {
    var P = window.Promise;
    var opt = { method: methode, credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    var p;
    if (typeof window.fetch !== 'function') return P.resolve({ netz: true });
    try { p = window.fetch(url, opt); } catch (e) { return P.resolve({ netz: true }); }
    return P.resolve(p).then(function (antwort) {
      var status = antwort && typeof antwort.status === 'number' ? antwort.status : 0;
      var text = antwort && typeof antwort.text === 'function' ? antwort.text() : '';
      return P.resolve(text).then(function (t) {
        var daten = null;
        try { daten = t ? JSON.parse(t) : null; } catch (e) { daten = null; }
        return { status: status, daten: istObjekt(daten) ? daten : null };
      }, function () { return { status: status, daten: null }; });
    }, function () { return { netz: true }; });
  }

  // Verzeichnis aus den Vorlagen der Sektion
  function leseVerzeichnis(w) {
    var liste = [];
    var vorlagen = w.querySelectorAll('template[data-mv-kontoseite-werkzeug], template[data-mv-kontoseite-praefix]');
    for (var i = 0; i < vorlagen.length; i++) {
      var v = vorlagen[i];
      var e = {
        werkzeug: v.getAttribute('data-mv-kontoseite-werkzeug') || '',
        praefix: v.getAttribute('data-mv-kontoseite-praefix') || '',
        name: v.getAttribute('data-mv-kontoseite-name') || '',
        url: v.getAttribute('data-mv-kontoseite-url') || '',
        anker: v.getAttribute('data-mv-kontoseite-anker') || '',
        vorlage: v
      };
      if ((e.werkzeug && SCHLUESSEL_RE.test(e.werkzeug)) || (e.praefix && /^[a-z0-9-]+-$/.test(e.praefix))) liste.push(e);
    }
    return liste;
  }

  function konfig(w) {
    var k = window.mvKonto;
    var login = w.querySelector('[data-mv-kontoseite-login]');
    var konto = w.querySelector('[data-mv-kontoseite-konto]');
    if (istObjekt(k)) {
      return {
        eingeloggt: k.eingeloggt === true,
        basis: basisAus(k.basis),
        loginUrl: adresseAus(k.loginUrl) || (login ? adresseAus(login.getAttribute('href')) : ''),
        kontoUrl: adresseAus(k.kontoUrl) || (konto ? adresseAus(konto.getAttribute('href')) : '')
      };
    }
    // ohne snippets/mv-konto-status.liquid: Werte der Sektion (Liquid customer, gleiche Bildung der Adressen)
    return {
      eingeloggt: w.getAttribute('data-mv-kontoseite-angemeldet') === 'true',
      basis: basisAus(w.getAttribute('data-mv-kontoseite-basis')),
      loginUrl: login ? adresseAus(login.getAttribute('href')) : '',
      kontoUrl: konto ? adresseAus(konto.getAttribute('href')) : ''
    };
  }

  function seite(w) {
    var s = { w: w, lauf: 0, zustand: null, verzeichnis: leseVerzeichnis(w), k: konfig(w), zeile: 0 };
    var liste = w.querySelector('[data-mv-kontoseite-liste]');
    var band = w.querySelector('[data-mv-kontoseite-teil="konto"]');
    var ueberschrift = band ? band.querySelector('.mv-bereich__titel') : null;
    var gastTitel = w.querySelector('[data-mv-kontoseite-teil="gast"] .mv-bereich__titel');
    var ansageEl = w.querySelector('[data-mv-kontoseite-ansage]');
    var vorlage = w.querySelector('template[data-mv-kontoseite-vorlage="eintrag"]');
    var standardIcon = w.querySelector('template[data-mv-kontoseite-icon-standard]');

    function meldung(name, wert) {
      var el = w.querySelector('[data-mv-kontoseite-meldung="' + name + '"]');
      if (!el) return '';
      var kopie = el.cloneNode(true);
      var slot = kopie.querySelector('[data-mv-kontoseite-meldung-name]');
      if (slot) slot.textContent = wert || '';
      return String(kopie.textContent || '').replace(/\s+/g, ' ').replace(/^ | $/g, '');
    }

    // Live-Region: gleicher Text noch einmal wird mit wechselndem Leerzeichen am Ende erneut angesagt
    function ansage(text) {
      if (!ansageEl || !text) return;
      ansageEl.textContent = ansageEl.textContent === text ? text + '\u00a0' : text;
    }

    function melde() {
      var ev;
      try {
        ev = new window.CustomEvent('mv-kontoseite:zustand', { bubbles: true, detail: { zustand: s.zustand } });
      } catch (e) {
        ev = null;
      }
      if (ev) w.dispatchEvent(ev);
    }

    function zeige(zustand) {
      s.zustand = zustand;
      if (w.getAttribute('data-mv-kontoseite-zustand') !== zustand) w.setAttribute('data-mv-kontoseite-zustand', zustand);
      var texte = w.querySelectorAll('[data-mv-kontoseite-text]');
      for (var i = 0; i < texte.length; i++) zeigeEl(texte[i], texte[i].getAttribute('data-mv-kontoseite-text') === zustand);
      var kontoLink = w.querySelector('[data-mv-kontoseite-konto]');
      zeigeEl(kontoLink, zustand !== 'gast' && !!s.k.kontoUrl);
      zeigeEl(w.querySelector('[data-mv-kontoseite-teil="gast"]'), zustand === 'gast');
      zeigeEl(band, zustand !== 'gast');
      zeigeEl(w.querySelector('[data-mv-kontoseite-teil="laedt"]'), zustand === 'laedt');
      zeigeEl(w.querySelector('[data-mv-kontoseite-teil="leer"]'), zustand === 'leer');
      zeigeEl(w.querySelector('[data-mv-kontoseite-teil="fehler"]'), zustand === 'fehler');
      zeigeEl(liste, zustand === 'liste');
      if (band) {
        if (zustand === 'laedt') band.setAttribute('aria-busy', 'true');
        else band.removeAttribute('aria-busy');
      }
      melde();
    }

    function links() {
      var login = w.querySelector('[data-mv-kontoseite-login]');
      if (login) {
        if (s.k.loginUrl) {
          if (login.getAttribute('href') !== s.k.loginUrl) login.setAttribute('href', s.k.loginUrl);
          zeigeEl(login, true);
        } else zeigeEl(login, false);
      }
      var konto = w.querySelector('[data-mv-kontoseite-konto]');
      if (konto && s.k.kontoUrl && konto.getAttribute('href') !== s.k.kontoUrl) konto.setAttribute('href', s.k.kontoUrl);
    }

    function zeile(e) {
      var v = ansicht(e, s.verzeichnis);
      var li = klonVorlage(vorlage);
      if (!li) return null;
      s.zeile += 1;
      li.setAttribute('data-mv-kontoseite-eintrag', v.werkzeug);
      setzeText(li.querySelector('[data-mv-kontoseite-name]'), v.name);
      var bez = li.querySelector('[data-mv-kontoseite-bezeichnung]');
      setzeText(bez, v.bezeichnung);
      zeigeEl(bez, !!v.bezeichnung);
      var zeit = li.querySelector('[data-mv-kontoseite-zeit]');
      var zeitwert = li.querySelector('[data-mv-kontoseite-zeitwert]');
      var zt = e.aktualisiert_am ? zeitText(e.aktualisiert_am, Date.now()) : '';
      if (zeitwert) {
        setzeText(zeitwert, zt);
        if (zt) zeitwert.setAttribute('datetime', e.aktualisiert_am);
      }
      zeigeEl(zeit, !!zt);
      var icon = li.querySelector('[data-mv-kontoseite-icon]');
      var quelle = v.treffer ? v.treffer.vorlage : standardIcon;
      var svg = klonVorlage(quelle) || klonVorlage(standardIcon);
      if (icon && svg) icon.appendChild(svg);
      var weiter = li.querySelector('[data-mv-kontoseite-weiter]');
      if (weiter) {
        if (v.url) weiter.setAttribute('href', v.url);
        else weiter.removeAttribute('href');
        zeigeEl(weiter, !!v.url);
      }
      var fuer = li.querySelectorAll('[data-mv-kontoseite-fuer]');
      for (var i = 0; i < fuer.length; i++) setzeText(fuer[i], ': ' + v.beschriftung);
      var frage = li.querySelector('[data-mv-kontoseite-frage]');
      var gruppe = li.querySelector('[data-mv-kontoseite-rueckfrage]');
      if (frage && gruppe) {
        frage.id = w.id + '-frage-' + s.zeile;
        gruppe.setAttribute('aria-labelledby', frage.id);
      }
      li.setAttribute('data-mv-kontoseite-beschriftung', v.beschriftung);
      return li;
    }

    function zeichne(eintraegeListe) {
      leere(liste);
      eintraegeListe.forEach(function (e) {
        var li = zeile(e);
        if (li && liste) liste.appendChild(li);
      });
    }

    function laden(nachAktion) {
      s.lauf += 1;
      var nr = s.lauf;
      zeige('laedt');
      if (!s.k.basis) {
        zeige('fehler');
        ansage(meldung('fehler'));
        return window.Promise.resolve('fehler');
      }
      return anfrage('GET', s.k.basis + '/uebersicht').then(function (r) {
        if (nr !== s.lauf) return 'veraltet';
        var a = art(r);
        if (a === 'gast') {
          zeige('gast');
          ansage(meldung('abgemeldet'));
          if (nachAktion) fokus(gastTitel);
          return 'gast';
        }
        var e = a === 'ok' ? eintraege(r.daten) : null;
        if (!e) {
          zeige('fehler');
          ansage(meldung('fehler'));
          if (nachAktion) fokus(ueberschrift);
          return 'fehler';
        }
        zeichne(e);
        zeige(e.length ? 'liste' : 'leer');
        if (nachAktion) {
          ansage(meldung('geladen'));
          fokus(ueberschrift);
        }
        return s.zustand;
      });
    }

    function rueckfrage(li, an) {
      var aktionen = li.querySelector('[data-mv-kontoseite-aktionen]');
      var gruppe = li.querySelector('[data-mv-kontoseite-rueckfrage]');
      zeigeEl(aktionen, !an);
      zeigeEl(gruppe, an);
      if (an) {
        zeigeEl(li.querySelector('[data-mv-kontoseite-loeschfehler]'), false);
        fokus(li.querySelector('[data-mv-kontoseite-frage]'));
      } else fokus(li.querySelector('[data-mv-kontoseite-aktion="loeschen"]'));
    }

    function loesche(li, knopf) {
      if (li.getAttribute('data-mv-kontoseite-loescht') === 'ja') return window.Promise.resolve('laeuft');
      var werkzeug = li.getAttribute('data-mv-kontoseite-eintrag') || '';
      if (!SCHLUESSEL_RE.test(werkzeug) || !s.k.basis) return window.Promise.resolve('ungueltig');
      var beschriftung = li.getAttribute('data-mv-kontoseite-beschriftung') || '';
      li.setAttribute('data-mv-kontoseite-loescht', 'ja');
      knopf.setAttribute('aria-busy', 'true');
      knopf.setAttribute('aria-disabled', 'true');
      return anfrage('DELETE', s.k.basis + '/stand?werkzeug=' + encodeURIComponent(werkzeug)).then(function (r) {
        var a = art(r);
        li.removeAttribute('data-mv-kontoseite-loescht');
        knopf.removeAttribute('aria-busy');
        knopf.removeAttribute('aria-disabled');
        if (a === 'ok') {
          if (li.parentNode) li.parentNode.removeChild(li);
          if (liste && !liste.querySelector('[data-mv-kontoseite-eintrag]')) zeige('leer');
          ansage(meldung('geloescht', beschriftung));
          fokus(ueberschrift);
          return 'geloescht';
        }
        if (a === 'gast') {
          s.lauf += 1;
          zeige('gast');
          ansage(meldung('abgemeldet'));
          fokus(gastTitel);
          return 'gast';
        }
        zeigeEl(li.querySelector('[data-mv-kontoseite-rueckfrage]'), false);
        zeigeEl(li.querySelector('[data-mv-kontoseite-aktionen]'), true);
        zeigeEl(li.querySelector('[data-mv-kontoseite-loeschfehler]'), true);
        ansage(meldung('loeschfehler'));
        fokus(li.querySelector('[data-mv-kontoseite-aktion="loeschen"]'));
        return 'fehler';
      });
    }

    function klick(ev) {
      var ziel = ev.target && ev.target.closest ? ev.target.closest('[data-mv-kontoseite-aktion]') : null;
      if (!ziel || !w.contains(ziel)) return;
      var aktion = ziel.getAttribute('data-mv-kontoseite-aktion');
      if (aktion === 'neu') {
        fokus(ueberschrift);
        laden(true);
        return;
      }
      var li = ziel.closest('[data-mv-kontoseite-eintrag]');
      if (!li) return;
      if (aktion === 'loeschen') rueckfrage(li, true);
      else if (aktion === 'abbrechen') rueckfrage(li, false);
      else if (aktion === 'bestaetigen') loesche(li, ziel);
    }

    function taste(ev) {
      if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
      var gruppe = ev.target && ev.target.closest ? ev.target.closest('[data-mv-kontoseite-rueckfrage]') : null;
      if (!gruppe || gruppe.hidden || !w.contains(gruppe)) return;
      var li = gruppe.closest('[data-mv-kontoseite-eintrag]');
      if (li && li.getAttribute('data-mv-kontoseite-loescht') !== 'ja') {
        ev.preventDefault();
        rueckfrage(li, false);
      }
    }

    w.addEventListener('click', klick);
    w.addEventListener('keydown', taste);
    links();
    var start = s.k.eingeloggt ? laden(false) : (zeige('gast'), window.Promise.resolve('gast'));

    return {
      w: w,
      start: start,
      laden: laden,
      zustand: function () { return s.zustand; },
      neu: function () {
        if (s.k.eingeloggt && s.zustand !== 'gast') return laden(false);
        return window.Promise.resolve(s.zustand);
      }
    };
  }

  function starten(bereich) {
    var wurzel = bereich && typeof bereich.querySelectorAll === 'function' ? bereich : document;
    var liste = [];
    if (wurzel.matches && wurzel.matches(WURZEL)) liste.push(wurzel);
    var innen = wurzel.querySelectorAll(WURZEL);
    for (var i = 0; i < innen.length; i++) liste.push(innen[i]);
    seiten = seiten.filter(function (x) { return x.w.isConnected !== false; });
    liste.forEach(function (w) {
      for (var j = 0; j < seiten.length; j++) if (seiten[j].w === w) return;
      seiten.push(seite(w));
    });
    return seiten;
  }

  MV.kontoseite = { version: VERSION, logik: logik, starten: starten, seiten: function () { return seiten.slice(); } };

  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });

  // Zurueck-Taste: Seite aus dem Cache des Browsers -> Liste neu laden (Stand kann sich im Werkzeug geaendert haben)
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    seiten.forEach(function (x) { x.neu(); });
  });

  // Teil des Buendels: diese Datei steht vor konto.js; erst nach dem ganzen Buendel starten (Mikrotask)
  function nachBuendel(fn) {
    if (typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(fn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nachBuendel(starten); });
  else nachBuendel(starten);
})();
